export default __webpack_public_path__ + "static/media/angela.aebf4cec.jpeg";